// extracted by css-extract-rspack-plugin
export default {"deviceChangeDetailsContainer":"src-domain-components-device-change-details-DeviceChangeDetails-module__deviceChangeDetailsContainer-CLap60"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"deviceChangeDetailsContainer\":\"src-domain-components-device-change-details-DeviceChangeDetails-module__deviceChangeDetailsContainer-CLap60\"}";
        // 1792611263622
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  